<template lang="pug">
.news-item.h-100
  a(:href='item.link')
    picture
      source(:srcset='item.images.thumb_news | webp')
      img(:src='item.images.thumb_news')
  .p-4
    h4 
      a.text-decoration-none.link-primary.fs-22.fw-bold(:href='item.link') {{ item.title }}
    .badge.bg-secondary.mb-4 {{ item.agency.name }}
    p.news-excerpt.mb-0(v-html='item.excerpt')
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
}
</script>